<div class="background glass">

    <div class="mt-3 d-flex justify-content-center">
        Create New Post
    </div>
    <hr>
    <div class="mx-3 mb-3">
        <label class="mb-1">Message</label>
        <div class="pane w-100 d-flex align-items-end">
            <textarea class="input"
                      rows="3"
                      placeholder="Type here..."
                      [(ngModel)]="textInput"></textarea>
        </div>
    </div>
    <hr class="hr-light">
    <div class="mx-3 mb-3">
        <label class="mb-1">Add media</label>
        <div *ngIf="uploadStatuss.length > 0" class="card w-100 bg-dark my-3">
            <div class="pane text-light overflow-scroll w-100 d-flex flex-wrap" style="max-height: 30vh;">
                @for (upload of uploadStatuss; track upload) {
                    <div class="image-item" style="
                            background-size: cover;
                            background:
                            /* top, transparent black overlay */
                            linear-gradient(
                                rgba(50, 25, 19, 0.5),
                                rgba(50, 25, 19, 0.5)
                            ),
                            /* bottom, image */
                            url('{{upload.fileData}}');
                        ">
                        <div class="mb-1 d-flex justify-content-between">
                            <div>{{ upload.name }}</div>
                            <div class="pointer ps-3 pe-1" (click)="removeImage(upload.id)">x</div>
                        </div>
                        <div class="mb-1 small" *ngIf="!upload.completed">Uploading</div>
                        <div class="mb-1 small" *ngIf="upload.completed">Uploaded</div>
                        <div class="progress mt-2" style="">
                            <div class="progress-bar" role="progressbar" style="width: {{ (upload.progress / upload.total) * 100 }}%">
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
        <div class="d-flex justify-content-center my-2">
            <label class="btn-primary mx-2"  for="file-upload">Add Images</label>
            <input id="file-upload" type="file" (change)="filesSelected($event)" class="file-upload" multiple/>
            <div class="vertical-bar"></div>
            <button class="btn-out mx-2" disabled>Other content coming soon</button>
        </div>
    </div>
    <hr>

<!--  <input type="file" class="file-upload" (change)="filesSelected($event)" multiple />-->

    <div *ngIf="errorUploadsNotCompleted" class="d-flex justify-content-end me-4 small">Please wait for the files to upload</div>
  <div class="mt-3 d-flex justify-content-end w-100 mb-3 me-2 pe-4">
    <button class="btn-out me-2" (click)="closeHolder()">Cancel</button>
    <button class="btn-primary" (click)="post()" [disabled]="!allUploadsCompleted">Post</button>
  </div>
</div>


<!--<div class="glass context-holder">-->
<!--    <div class="px-3 py-4 d-flex flex-column align-items-center ">-->
<!--        <div class="image mx-5 my-3">-->
<!--            <base64-image [base64String]="profileImageB64"></base64-image>-->
<!--        </div>-->
<!--        <div class="profile-name">{{ user?.display_name }}</div>-->
<!--        <div class="profile-status">{{ user?.tag_line }}</div>-->
<!--    </div>-->
<!--    <ul class="list-group list-group-flush mb-3">-->
<!--        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"-->
<!--            (click)="viewProfile()">-->
<!--            <div>View Profile (coming soon)</div>-->
<!--            <fa-icon [icon]="iconsService.faIconsRegular.faUser"></fa-icon>-->
<!--        </li>-->
<!--        <li class="list-group-item list-group-item-action pointer d-flex justify-content-between align-items-center"-->
<!--            (click)="openChat()">-->
<!--            <div>Open chat</div>-->
<!--            <fa-icon [icon]="iconsService.faIconsRegular.faMessage"></fa-icon>-->
<!--        </li>-->
<!--        &lt;!&ndash;        <li class="list-group-item list-group-item-action pointer">A second item</li>&ndash;&gt;-->
<!--        &lt;!&ndash;        <li class="list-group-item list-group-item-action pointer">A third item</li>&ndash;&gt;-->
<!--        &lt;!&ndash;        <li class="list-group-item list-group-item-action pointer">A fourth item</li>&ndash;&gt;-->
<!--        &lt;!&ndash;        <li class="list-group-item list-group-item-action pointer">And a fifth one</li>&ndash;&gt;-->
<!--    </ul>-->
<!--</div>-->
